import React from "react";
import {
  Box,
  Container,
  Fade,
  LinearProgress,
  Typography,
} from "@mui/material";
import { useNavigation } from "react-router-dom";

interface IPageProps {
  title?: string;
  isLoading?: boolean;
  children: React.ReactNode;
}

const Page = (props: IPageProps) => {
  const { title, isLoading, children } = props;
  const navigation = useNavigation();
  return (
    <Box>
      <Box sx={{ width: "100%", height: 2 }}>
        <Fade
          in={isLoading || navigation.state === "loading"}
          style={{
            transitionDelay: isLoading ? "800ms" : "0ms",
          }}
          unmountOnExit
        >
          <LinearProgress />
        </Fade>
      </Box>
      <Container disableGutters maxWidth="sm">
        <Box sx={{ padding: title ? 2 : 0 }}>
          {title && (
            <Typography variant={"h5"} sx={{ paddingBottom: 2 }}>
              {title}
            </Typography>
          )}
          {children}
        </Box>
      </Container>
    </Box>
  );
};

export default Page;
